import { render, staticRenderFns } from "./PaginationSection.vue?vue&type=template&id=e49d73ee&scoped=true"
import script from "./PaginationSection.vue?vue&type=script&lang=ts"
export * from "./PaginationSection.vue?vue&type=script&lang=ts"
import style0 from "./PaginationSection.vue?vue&type=style&index=0&id=e49d73ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49d73ee",
  null
  
)

export default component.exports